import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { TikTokIcon } from "./icons";
import { MANIFESTO, IMAGES, LINKS } from "../../data";

export const Manifesto = () => (
  <section id="story" className="relative bg-black px-5 sm:px-8 lg:px-12 py-24 sm:py-32">
    <div className="mx-auto max-w-[1600px] grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-start">
      {/* Left: chapters */}
      <div className="order-2 lg:order-1">
        <Reveal>
          <span className="font-graffiti text-neon-yellow text-4xl sm:text-5xl -rotate-2 inline-block">
            straight up
          </span>
          <h2 className="font-heading text-5xl sm:text-6xl lg:text-7xl text-white uppercase tracking-tight leading-none mt-2">
            Why <span className="text-neon-green">67?</span>
          </h2>
        </Reveal>

        <div className="mt-12 flex flex-col divide-y divide-neon-green/15 border-t border-neon-green/15">
          {MANIFESTO.map((m, i) => (
            <Reveal key={m.num} delay={i * 0.08}>
              <div className="group flex gap-6 py-8 transition-colors duration-300 hover:bg-neon-green/[0.03]">
                <span className="font-graffiti text-neon-yellow text-4xl sm:text-5xl leading-none shrink-0 w-16">
                  {m.num}
                </span>
                <div>
                  <h3 className="font-heading text-3xl sm:text-4xl text-white uppercase tracking-wide group-hover:text-neon-green transition-colors duration-300">
                    {m.title}
                  </h3>
                  <p className="font-body text-neutral-400 mt-2 max-w-md leading-relaxed">{m.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      {/* Right: truck image, clipped */}
      <Reveal delay={0.15} className="order-1 lg:order-2">
        <motion.div
          whileHover={{ scale: 1.01 }}
          transition={{ duration: 0.4 }}
          className="relative lg:sticky lg:top-28 overflow-hidden border border-neon-green/25"
        >
          <img
            src={IMAGES.truck}
            alt="67 Wings & Tenders neon green food truck"
            className="w-full h-[420px] sm:h-[560px] object-cover transition-transform duration-700 hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent pointer-events-none" />
          <div className="absolute bottom-5 left-5 right-5 flex flex-wrap items-end justify-between gap-3">
            <span className="font-graffiti text-neon-green text-3xl sm:text-4xl neon-glow-green">
              Find the green truck!
            </span>
            <a
              href={LINKS.tiktok}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="truck-tiktok-link"
              className="inline-flex items-center gap-2 font-heading text-base sm:text-lg tracking-wide bg-neon-green text-black px-4 py-2 hover:bg-neon-yellow transition-colors duration-200"
            >
              <TikTokIcon size={18} /> See where we moved
            </a>
          </div>
        </motion.div>
      </Reveal>
    </div>
  </section>
);

export default Manifesto;
